import React, {Component} from 'react';
import axios from 'axios';
import Header from './components/Header';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import BeforeLogin from './components/BeforeLogin';
import UpcomingBanner from "./components/UpcomingBanner";
import PageNotFound from "./components/PageNotFound";
import Welcome from "./components/Welcome";
import BracBankRequiredLogin from './components/BracBankRequiredLogin';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogin: "false",
            otpStatus: "false",
            invalidProgram: false,
            programLoad: false,            
            userName:localStorage.userName ? localStorage.userName : '',
        }
        this.programLoaded = false;
        this.programStatus = null;
        this.urlParams = new URLSearchParams(window.location.search);
        this.bannerStatus = 0; //false
        // this.isDemo = false;
        this.programCountDownTime = null;
        this.proposedSecondedFeature = 0;
        this.voteHereBlock = 0;
        this.key = 'YUIKjuiKJIolkqUiWFDIE5LALyuiolSDwsDXCvBWzMq2gwWBvJcS8kl7RTYuJHTyuj';
        // localStorage.setItem('apiHost', 'http://127.0.0.1:8000/api');
        localStorage.setItem('apiHost','https://earningdisclosureadmin.comjagat.org/api');
        // localStorage.setItem('apiHost','https://test-goconadmin.comjagat.org/api');
        // localStorage.setItem('apiHost','https://edadminaws.comjagat.org/api');

        // localStorage.setItem('mainHost', 'http://127.0.0.1:8000');
        localStorage.setItem('mainHost', 'https://earningdisclosureadmin.comjagat.org');
        // localStorage.setItem('mainHost', 'https://test-goconadmin.comjagat.org');
        // localStorage.setItem('mainHost', 'https://edadminaws.comjagat.org');
        localStorage.programId = this.urlParams.get('program');
        localStorage.isLogin = localStorage.isLogin === 'true' ? 'true' : 'false';
        localStorage.demoURL = "";
        localStorage.demoURL2 = "";
        if (this.urlParams.has('demo')) {

            localStorage.demoURL = this.urlParams.get('demo');

        }
    }

    changeLoginStatus = (value, name) => {

        localStorage.isLogin = value; 

        this.setState({userName: name});

        this.setState({isLogin: value});

        let log = document.getElementById('loginClose');
        let reg = document.getElementById('registerClose');

        if(log){log.click()}
        if(reg){reg.click()}

        let modOv = document.getElementsByClassName('modal-backdrop');

        if(modOv[0]) {modOv[0].parentNode.removeChild(modOv[0]);} 
    }
    

    loadData = (program) => {
        localStorage.programName = program.program_name;
        localStorage.programDate = program.program_date;
        localStorage.programLogo = program.program_logo;
        localStorage.programIcon = program.program_icon;
        localStorage.programLiveArchiveVideoLink = program.live_archive_video_link;
        localStorage.downloadPresentationLink = program.download_presentation_link;
        localStorage.programStatus = program.status;
        this.programStatus = program.status;

        this.bannerStatus = program.banner_status;
        this.programCountDownTime = program.program_countdown_endtime;

        localStorage.programQuestionStatus = program.question_status;

        localStorage.programBanner = program.program_banner;
        localStorage.programVideo = program.program_video;
        localStorage.helpline = program.helpline;

        localStorage.noticeStatus = program.notice_status;
        localStorage.noticeText = program.notice_text;
        localStorage.countdownText = program.countdown_text;

        localStorage.programSpeakerStatus = program.speaker_status;
        localStorage.programSpeakerUpcommingText = program.speaker_upcomming_text;
        localStorage.programSliderStatus = program.slider_status;
        localStorage.programsliderUpcommingText = program.slider_upcomming_text;
        localStorage.questionDisabledText = program.question_disabled_text;
        localStorage.loginSubmitQuestionText = program.login_submit_question_text;
        localStorage.downloadPresentationStatus = program.download_presentation_status;


        // brending

        localStorage.navigationBarBgColor = program.navigationbar_bg_color;
        localStorage.navigationBarTextColor = program.navigationbar_text_color;

        localStorage.commentHeaderBgColor = program.comment_header_bg_color;
        localStorage.commentHeaderTextColor = program.comment_header_text_color;

        localStorage.commentNameBgColor = program.comment_name_bg_color;
        localStorage.commentNameTextColor = program.comment_name_text_color;

        localStorage.commentDateBgColor = program.comment_date_bg_color;
        localStorage.commentDateTextColor = program.comment_date_text_color;


        localStorage.commentTextBgColor = program.comment_text_bg_color;
        localStorage.commentTextColor = program.comment_text_color;


        localStorage.speakerBgColor = program.speaker_bg_color;
        localStorage.speakerTextColor = program.speaker_text_color;


        localStorage.footerBgColor = program.footer_bg_color;
        localStorage.footerTextColor = program.footer_text_color;



        localStorage.loginBtnBgColor = program.login_btn_bg_color;
        localStorage.loginBtnTextColor = program.login_btn_text_color;



        localStorage.logoutBtnBgColor = program.logout_btn_bg_color;
        localStorage.logoutBtnTextColor = program.logout_btn_text_color;


        localStorage.downloadBtnBgColor = program.download_btn_bg_color;
        localStorage.downloadBtnTextColor = program.download_btn_text_color;

        localStorage.registerBtnStatus = program.register_btn_status;
        localStorage.registerBtnBgColor = program.register_btn_bg_color;
        localStorage.registerBtnTextColor = program.register_btn_text_color;

        localStorage.forgetPassStatus = program.forget_password_show_status;
        localStorage.bracBankRequiredLogin = program.brac_bank_required_login;
        localStorage.demoURL2 = program.demo_login_pass;
        localStorage.comment_view_with_login = program.comment_view_with_login;
        
        this.setState({programLoad: true});
        
    }

    componentDidMount = () => {

        if (this.urlParams.has('program')) {

            axios({
                method: 'post',
                url: `${localStorage.apiHost}/program-details`,
                headers: {
                    'key': this.key
                },
                data: {
                    'program-id': localStorage.programId
                }
            }).then(response => {
                if (response.data.status === 200) {
                    let program = response.data[0];
                    // let programLocalization = response.data['localization'];
                    // this.loadLocalization(programLocalization);
                    // console.log("program data", program);
                    this.loadData(program);
                    // this.checkDemo(program.demo_login_pass);
                    // console.log(program.demo_login_pass);
                }
            });

        } else {

            this.setState({invalidProgram: true});

        }

    }

    // checkDemo = (demoPass) => {

    //     console.log ('this is the demo - '+demoPass)
    //     console.log ('this is the demo url - '+this.urlParams.get('demo'))

    //     if (this.urlParams.has('demo')) {

    //         if (this.urlParams.get('demo') === ""+demoPass) {
    //             this.isDemo = true;
    //         } else {
    //             this.setState({invalidProgram: true});
    //         }

    //     }

    // }

    stripHtml = (html) => {
        // Create a new div element
        var temporalDivElement = document.createElement("div");
        // Set the HTML content with the providen
        temporalDivElement.innerHTML = html;
        // Retrieve the text property of the element (cross-browser support)
        return temporalDivElement.textContent || temporalDivElement.innerText || "";
    }

    render() {

        if(localStorage.programIcon !== "null"){

            let iconEl = document.getElementById('icon');
            iconEl.href = `data:image/jpeg;base64,${localStorage.programIcon}`;

        }

        if(localStorage.programName !== "null"){            
            
            let titleEl = document.getElementById('site-title');
            
            titleEl.innerHTML = this.stripHtml(localStorage.programName);
                         
        }    

        // console.log(localStorage.bracBankRequiredLogin);

        let element;

        if (this.state.invalidProgram) {

            element = <PageNotFound/>

        } else {            

            if(this.state.programLoad === true){

                if (this.bannerStatus === 1) {

                    if (localStorage.demoURL2 === localStorage.demoURL){

                        if(localStorage.demoURL2 != ''){

                            if(localStorage.bracBankRequiredLogin === '1'){
    
                                {this.state.isLogin === 'true' || localStorage.isLogin === 'true' ?
    
                                    element = <><Header/><NavBar userName={this.state.userName} onClick={this.changeLoginStatus} isLogin={this.state.isLogin} programStatus={this.programStatus}/><BeforeLogin isLogin={this.state.isLogin} programStatus={this.programStatus}/><Footer/></>
    
                                :
    
                                    element = <><Header/><BracBankRequiredLogin userName={this.state.userName} onClick={this.changeLoginStatus} isLogin={this.state.isLogin} programStatus={this.programStatus}/><Footer/></>;
    
                                }
    
                            }else{
    
                                element = <><Header/><NavBar userName={this.state.userName} onClick={this.changeLoginStatus} isLogin={this.state.isLogin} programStatus={this.programStatus}/><BeforeLogin isLogin={this.state.isLogin} programStatus={this.programStatus}/><Footer/></>
    
                            }    

                        }else{

                            element = <PageNotFound/>

                        }                        
    
                    }else{

                        element = <UpcomingBanner programStatus={this.programStatus} countDownTime={this.programCountDownTime}/>
                    }


                }else{

                    if(localStorage.demoURL == ''){

                        if(localStorage.bracBankRequiredLogin === '1'){

                            {this.state.isLogin === 'true' || localStorage.isLogin === 'true' ?

                                element = <><Header/><NavBar userName={this.state.userName} onClick={this.changeLoginStatus} isLogin={this.state.isLogin} programStatus={this.programStatus}/><BeforeLogin isLogin={this.state.isLogin} programStatus={this.programStatus}/><Footer/></>

                            :

                                element = <><Header/><BracBankRequiredLogin userName={this.state.userName} onClick={this.changeLoginStatus} isLogin={this.state.isLogin} programStatus={this.programStatus}/><Footer/></>;

                            }

                        }else{

                            element = <><Header/><NavBar userName={this.state.userName} onClick={this.changeLoginStatus} isLogin={this.state.isLogin} programStatus={this.programStatus}/><BeforeLogin isLogin={this.state.isLogin} programStatus={this.programStatus}/><Footer/></>

                        } 

                    }else{

                        element = <PageNotFound/>
                        
                    }

                }
            }

        }

        return (
            <div>
                {
                    window.location.pathname.length > 1
                    ?
                    <div>
                        {element}
                    </div>
                    :
                    <Welcome/>
                }
            </div>
        );
    }

}

export default App;
